import { Routes } from "@angular/router";
import { RolesListComponent } from "./roles-list/roles-list.component";
import { RoleCreateComponent } from "./role-create/role-create.component";
import { RoleEditComponent } from "./role-edit/role-edit.component";
import { RoleDeleteComponent } from "./role-delete/role-delete.component";
import { RoleDetailsComponent } from "./role-details/role-details.component";
import { actionsGuard } from "../shared/guards/actions.guard";

export const rolesRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: RolesListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: RoleCreateComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: RoleEditComponent, canActivate: [actionsGuard] },
  { path: 'delete/:id', component: RoleDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: RoleDetailsComponent, canActivate: [actionsGuard] },
]
